var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkout-section" }, [
    _c("div", { staticClass: "checkout-iframe" }, [
      _vm.paymentFrame
        ? _c("iframe", { attrs: { src: _vm.paymentFrame.url } })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "checkout-section__footer" },
      [
        _c("NavButton", {
          class: {
            "btn btn--outline-gray-color btn--outline-gray-color_sm resultCardMapTs":
              _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
          },
          attrs: {
            back: true,
            text: "Back",
            brand: _vm.data.brandNameFormatted,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }